module.exports = __webpack_public_path__ + "static/media/logo.efdbee20.svg";